<!--<nav mat-tab-nav-bar mat-align-tabs="center" ngClass.xs="hidden">-->
<!--  <a-->
<!--    mat-tab-footerElement-->
<!--    routerLinkActive="active-tab"-->
<!--    *ngFor="let footerElement of links"-->
<!--    [active]="activeLink === footerElement"-->
<!--    [routerLink]="footerElement.routerLink"-->
<!--    >{{ footerElement.tabLabel }}</a-->
<!--  >-->
<!--</nav>-->
<mat-tab-nav-panel>
  <!--  (swipeleft)="switchToRightTab($event)" (swiperight)="switchToLeftTab($event)"-->
  <div class="wrapper" *ngIf="(pending$ | async) === pendingState.success">
    <router-outlet></router-outlet>
  </div>
  <div class="spinner spinner-margin-top" *ngIf="(pending$ | async) === pendingState.pending">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="(pending$ | async) === pendingState.failed" class="wrapper">
    <mat-card class="confinement">
      <mat-card-title class="error-text">
        {{ 'ERROR.TITLE' | translate }}
      </mat-card-title>
      <mat-card-content class="error-text">
        {{ 'ERROR.DESCRIPTION' | translate }}
      </mat-card-content>
    </mat-card>
  </div>
</mat-tab-nav-panel>
